module.exports = __webpack_public_path__ + "img/icon-loading.f313cae8.svg";